import { get, patch, post, put, sharedApi } from 'utils/api/api';

import { ApiUser, RegistrationMetrics } from 'types/auth';
import {
  CheckEmailResponse,
  EmailConfig,
  LoginConfig,
  LoginResponse,
  SetUpPasswordConfig,
  SignUpConfig,
  UpdatePasswordConfig
} from 'types/auth';
import { ClientWorkspace } from 'types/auth';
import { GuideStep } from 'types/tour';

import {
  CHECK_EMAIL,
  CLIENTS_WORKSPACE_HOME,
  GET_USER,
  GUIDE,
  LOGIN,
  REGISTRATION_METRICS,
  RESET_PASSWORD,
  SETUP_PASSWORD,
  SIGNUP,
  UPDATE_PASSWORD, // WELCOME
  USER_PLATFORM_LANGUAGE
} from 'constants/endpoints';

class AuthService {
  async getUser(): Promise<ApiUser> {
    const response = await get(GET_USER);
    return response;
  }

  async login(config: LoginConfig): Promise<LoginResponse> {
    const response = await sharedApi.post(LOGIN, config);
    return response;
  }

  async signUp(config: SignUpConfig): Promise<void> {
    const response = await sharedApi.post(SIGNUP, config);
    return response;
  }

  async updatePassword(config: UpdatePasswordConfig): Promise<void> {
    await sharedApi.put(UPDATE_PASSWORD, config);
  }

  async resetPassword(config: EmailConfig): Promise<void> {
    await sharedApi.post(RESET_PASSWORD, config);
  }

  async checkEmail(config: EmailConfig): Promise<CheckEmailResponse> {
    const response = await sharedApi.post(CHECK_EMAIL, config);
    return response;
  }

  async setUpPassword(config: SetUpPasswordConfig): Promise<LoginResponse> {
    const response = await sharedApi.post(SETUP_PASSWORD, config);
    return response;
  }

  async getClientWorkspace(): Promise<ClientWorkspace> {
    const response = await get(CLIENTS_WORKSPACE_HOME);
    return response;
  }

  async readGuideSteps(guide: GuideStep): Promise<void> {
    await put(GUIDE, guide);
  }

  async updatePlatformLanguage(language: string): Promise<void> {
    await patch(USER_PLATFORM_LANGUAGE, {
      language: language.toUpperCase()
    });
  }

  async getRegistrationMetrics(): Promise<RegistrationMetrics> {
    const response = await get(REGISTRATION_METRICS);
    return response;
  }
}

export default new AuthService();
